import React from 'react';
import PropTypes from 'prop-types';
import cx from 'src/classnames';
import styles from './Title.module.scss';

Title.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'big']),
  weight: PropTypes.oneOf(['regular', 'bold']),
};

function Title({ children, className, size, weight, ...other }) {
  return (
    <span
      {...other}
      className={cx(
        styles.title,
        {
          [styles.small]: size === 'small',
          [styles.medium]: size === 'medium',
          [styles.big]: size === 'big',
          [styles.bold]: weight === 'bold',
        },
        className,
      )}
    >
      {children}
    </span>
  );
}

export default Title;
